export function toFen(yuan = 0) {
  /**
   * REVIEW
   * 2341.8 * 100 => 234180.00000000003
   */
  // return yuan * 100
  return Math.round(yuan * 100);
}

export function toYuan(fen = 0) {
  return Number((fen / 100).toFixed(2));
}
